interface ModalProps {
  onClick?: any
  tall?: boolean
  children: React.ReactNode
}

const Modal: React.FunctionComponent<ModalProps> = ({
  onClick,
  tall,
  children
}) => {
  return (
    <div className='bg-black flex justify-center items-center w-full md:w-auto' data-testid='modal-background'>
      <div className='glow-effect w-full md:w-auto' data-testid='modal-glow'>
        <div className='diamond-corner p-[4px] bg-dopage-lightGreen min-h-[400px] w-full max-w-[440px] mx-auto md:max-w-full md:min-w-[670px]' data-testid='modal-diamond'>
          <div className={`${tall === true ? 'md:min-h-768:h-[750px] md:min-h-1024:h-[820px]' : ''} inner bg-black h-auto md:h-[580px]`} data-testid='modal-inner'>
            <div className='p-4 md:p-[22px] flex flex-col items-center text-dopage-lightGreen h-full'>
              {children}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Modal
